import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';

interface SubscribeButtonProps {
    type?: string;
    onClick?: () => void;
}

const SubscribeButton2: React.FC<SubscribeButtonProps> = ({ type, onClick }) => {
    const t = useTranslations("messages");

    return (
        <Button
            className="!bg-ciBlue_900 flex !gap-[4px] lg:!gap-[8px] items-center justify-center !px-[12px] lg:!px-[16px] !py-[8px] lg:!py-[24px] !rounded-[4px] report-subscribe-notice-button"
            onClick={onClick}
            sx={{
                width: '100%',
                maxWidth: { xs: '100%', sm: '100%', lg: `${type === 'PopupFilterLocked' ? '100%' : '320px'}`, xl: `${type === 'PopupFilterLocked' ? '100%' : '472px'}` },
                height: 'auto',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                '&:hover': {
                    backgroundColor: '#0056b3 !important',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                },
            }}
        >
            <Box
                className="flex flex-col items-center justify-center text-center"
                sx={{
                    maxWidth: '100%',
                    overflowWrap: 'break-word',
                }}
            >
                {/* <Typography
                    variant="body1"
                    className='!text-white !font-[Montserrat,sans-serif] !font-[500] !text-[12px] lg:!text-[16px] !leading-[20px] lg:!leading-[24px] !tracking-[0px]'
                    translation-key="report_subscribe_notice_button_subtitle"
                    sx={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        textAlign: 'center',
                    }}
                >
                    {t("report_subscribe_notice_button_subtitle")}
                </Typography> */}
                <Typography
                    variant="h6"
                    className='!text-white !font-[Montserrat,sans-serif] !font-[600] !text-[20px] lg:!text-[26px] !leading-[20px] lg:!leading-[24px] !tracking-[0px]'
                    translation-key={type === 'PopupFilterLocked' ? "report_subscribe_notice_upgrade_now" : "report_subscribe_notice_button_title"}
                    sx={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        textAlign: 'center',
                    }}
                >
                    {type === 'PopupFilterLocked' ? t("report_subscribe_notice_upgrade_now") : t("report_subscribe_notice_button_title")}
                </Typography>
            </Box>
        </Button>
    );
};

export default SubscribeButton2;